import React from "react";
import clsx from "clsx";

import { ILesson } from "../../../state";
import { prefixPath, projectionPath } from "../../../teacherStore";
import { ReactComponent as ProjectorIcon } from "../../../assets/svg/projector_2.svg";
// import { ReactComponent as VideoProjectorIcon } from "../../../assets/svg/video_projector.svg";

import styles from "./GuidelineSidebar.module.scss";

export interface GuidelineSidebarProps {
  lesson: ILesson | null;
  classListString: string;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

export const GuidelineSidebar: React.FC<GuidelineSidebarProps> = ({
  lesson,
  classListString,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  const onShareMaterial = () =>
    lesson &&
    window.open(
      `${prefixPath}${projectionPath}?lesson=${lesson.id}&page=1&classList=${classListString}`,
      "_blank",
    );

  const prevLesson = () => prevLessonId && onChangeLesson(prevLessonId);
  const nextLesson = () => nextLessonId && onChangeLesson(nextLessonId);

  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <button
          className={clsx(
            styles.whiteSquareBtn,
            lesson?.teacher_only && styles.invisible,
          )}
          onClick={onShareMaterial}
        >
          <div className={styles.iconWrapper}>
            <ProjectorIcon className={styles.projectorIcon} />
          </div>
          <span className={styles.btnText}>教材を投影</span>
        </button>
        {/* 動画教材を投影
        <button className={styles.whiteSquareBtn} onClick={() => {}}>
          <div className={styles.iconWrapper}>
            <VideoProjectorIcon className={styles.projectorIcon} />
          </div>
          <span className={styles.btnText}>動画教材を投影</span>
        </button> */}
      </div>
      <div className={styles.bottomSection}>
        <button
          onClick={prevLesson}
          disabled={!prevLessonId}
          className={styles.navBtn}
        >
          前の指導書
        </button>
        <button
          onClick={nextLesson}
          disabled={!nextLessonId}
          className={styles.navBtn}
        >
          次の指導書
        </button>
      </div>
    </div>
  );
};

export default GuidelineSidebar;
